__turbopack_context__.v({
  "BlueGreen": "_UIXia_BlueGreen",
  "Checkbox": "_UIXia_Checkbox",
  "CheckboxItem": "_UIXia_CheckboxItem",
  "CheckboxLabel": "_UIXia_CheckboxLabel",
  "ErrorMessage": "_UIXia_ErrorMessage",
  "Field": "_UIXia_Field",
  "File": "_UIXia_File",
  "FileIcon": "_UIXia_FileIcon",
  "HasError": "_UIXia_HasError",
  "HasValue": "_UIXia_HasValue",
  "InfoMessage": "_UIXia_InfoMessage",
  "Input": "_UIXia_Input",
  "InputField": "_UIXia_InputField",
  "InputFieldOther": "_UIXia_InputFieldOther",
  "IsWhite": "_UIXia_IsWhite",
  "Label": "_UIXia_Label",
  "LargeCheckbox": "_UIXia_LargeCheckbox",
  "PinkBlue": "_UIXia_PinkBlue",
  "PinkOrange": "_UIXia_PinkOrange",
  "PinkPurple": "_UIXia_PinkPurple",
  "PurpleBlue": "_UIXia_PurpleBlue",
  "Radio": "_UIXia_Radio",
  "RadioGroup": "_UIXia_RadioGroup",
  "RadioHelpText": "_UIXia_RadioHelpText",
  "RadioItem": "_UIXia_RadioItem",
  "RadioItemWithHelp": "_UIXia_RadioItemWithHelp",
  "RadioLabel": "_UIXia_RadioLabel",
  "RadioMark": "_UIXia_RadioMark",
  "RadioRow": "_UIXia_RadioRow",
  "Required": "_UIXia_Required",
  "TextArea": "_UIXia_TextArea",
});
